var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingsStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1970.000000, -638.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buildings/Store",
    transform: "translate(1970.000000, 638.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,10 C30,11.104 29.104,12 28,12 C26.896,12 26,11.104 26,10 C26,11.104 25.104,12 24,12 C22.896,12 22,11.104 22,10 C22,11.104 21.104,12 20,12 C18.896,12 18,11.104 18,10 C18,11.104 17.104,12 16,12 C14.896,12 14,11.104 14,10 C14,11.104 13.104,12 12,12 C10.896,12 10,11.104 10,10 C10,11.104 9.104,12 8,12 C6.896,12 6,11.104 6,10 C6,11.104 5.104,12 4,12 C2.896,12 2,11.104 2,10 L2,5 L30,5 L30,10 Z M22,24.286 L30,24.286 L30,15 L22,15 L22,24.286 Z M13,28 L19,28 L19,15 L13,15 L13,28 Z M2,24.286 L10,24.286 L10,15 L2,15 L2,24.286 Z M4,2 C1.791,2 0,3.791 0,6 L0,30 L28,30 C30.209,30 32,28.209 32,26 L32,2 L4,2 Z",
    id: 57
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsStore);
export default __webpack_public_path__ + "static/media/buildings-store.7744fc34.svg";
export { ForwardRef as ReactComponent };